<div class="header"> 
    <ng-template #start>  
        <img class="mr-3" src="assets/images/logo.svg" alt="Logo" />
      </ng-template>
  <app-menu></app-menu>
 
</div>